import React from 'react';
import Button from '@material-ui/core/Button';

import withStyles from '@material-ui/core/styles/withStyles';
import variables from '../../styles/variables.module.scss';

const styles = {
  contained: {
    color: variables.carbonBlack,
    backgroundColor: variables.springGreen,
    borderRadius: 0,
    height: 60,
    '&:hover': {
      backgroundColor: `${variables.shamrockGreen} !important`,
    },
  },
  disabled: {
    backgroundColor: `${variables.springGreen} !important`,
    opacity: 0.3,
  },
};

const DefaultTextField = ({
  classes,
  children,
  ...props
}) => (
  <Button
    type="submit"
    variant="contained"
    size="large"
    fullWidth
    classes={{
      contained: classes.contained,
      disabled: classes.disabled,
    }}
    {...props}
  >
    {children}
  </Button>
);

export default withStyles(styles)(DefaultTextField);
